import type { WebsiteContent } from './types'

export const hero: WebsiteContent['hero'] = {
  subtitle: 'Build smarter. Move faster. Win sooner.',
  description:
    'Human-first AI solutions that empower teams in retail, finance, healthcare, and higher education.',
}
